import React from 'react';

export default function AboutHero() {
  return (
    <section 
      className="relative py-12 sm:py-16 md:py-20 min-h-[60vh] sm:min-h-[70vh] flex items-center"
      style={{
        backgroundImage: `url('https://readdy.ai/api/search-image?query=Peaceful%20ayurvedic%20wellness%20center%20with%20traditional%20herbs%2C%20mortar%20and%20pestle%2C%20ancient%20texts%2C%20natural%20lighting%2C%20serene%20atmosphere%2C%20wooden%20elements%2C%20meditation%20space%2C%20organic%20textures%2C%20warm%20earth%20tones%2C%20professional%20photography%20style%2C%20minimalist%20composition%2C%20wellness%20sanctuary&width=1920&height=800&seq=abouthero1&orientation=landscape')`,
        backgroundSize: 'cover',
        backgroundPosition: 'center'
      }}
    >
      <div className="absolute inset-0 bg-gradient-to-r from-green-900/80 to-green-700/60"></div>
      
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6">
        <div className="max-w-3xl text-white">
          <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold mb-6 leading-tight">
            Our Journey of
            <span className="text-green-300 block">Natural Healing</span>
          </h1>
          
          <p className="text-base sm:text-lg md:text-xl mb-8 leading-relaxed opacity-90">
            For over two decades, we've been dedicated to bringing the ancient wisdom of Ayurveda 
            to modern lives, creating authentic products that restore balance and promote natural wellness.
          </p>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 sm:gap-8">
            <div className="text-center">
              <div className="text-2xl sm:text-3xl font-bold text-green-300 mb-2">20+</div>
              <div className="text-sm sm:text-base text-green-100">Years of Experience</div>
            </div>
            <div className="text-center">
              <div className="text-2xl sm:text-3xl font-bold text-green-300 mb-2">100K+</div>
              <div className="text-sm sm:text-base text-green-100">Happy Customers</div>
            </div>
            <div className="text-center">
              <div className="text-2xl sm:text-3xl font-bold text-green-300 mb-2">50+</div>
              <div className="text-sm sm:text-base text-green-100">Premium Products</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}